export default "__VITE_ASSET__D28HzZus__"